import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values  = { copiedLabel: { type: String, default: "Skopírované ✓" } }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.textContent.trim())
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = this.copiedLabelValue
      setTimeout(() => { this.buttonTarget.textContent = original }, 2000)
    } catch (error) {
      console.warn("Clipboard write failed", error)
    }
  }
}
